import { initSentry } from "@pex/observability/client";

initSentry(process.env.NEXT_PUBLIC_FINDER_SENTRY_DSN ?? "");
